import client from "../libs/HttpClient";

class NewsArticleServices {
  static viewNewsArticle(params) {
    console.log("params", params);
    return client.get(`/newsarticle`, { params });
  }
  static listNewsArticle(params) {
    return client.get(`/news`, { params });
  }
}

export { NewsArticleServices };
